import React from 'react';
import classNames from 'classnames';

import css from './IconArrowBack.module.css';

/**
 * IconArrowBack icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconArrowBack = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_2518_5230)">
<path fillRule="evenodd" clipRule="evenodd" d="M16.4334 4.93432C17.2498 4.11778 17.2498 2.79405 16.4334 1.97758C15.6169 1.16112 14.2931 1.16112 13.4767 1.97758L0.932662 14.5216C0.116196 15.3381 0.116196 16.6618 0.932662 17.4783L13.4767 30.0223C14.2932 30.8387 15.6169 30.8387 16.4334 30.0223C17.2498 29.2058 17.2498 27.8821 16.4334 27.0656L7.45833 18.0907H29.5897C30.7443 18.0907 31.6803 17.1546 31.6803 15.9999C31.6803 14.8453 30.7443 13.9093 29.5897 13.9093H7.45833L16.4334 4.93432Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2518_5230">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
  );
};

export default IconArrowBack;
